module.exports = __webpack_public_path__ + "img/herodaoname.aebbcd68.svg";